import { AuthProvider } from '@pankod/refine-core'
import { CredentialResponse, googleLogout } from '@react-oauth/google'
import Cookies from 'js-cookie'
import { notification } from '@pankod/refine-antd'

import { fetchGuruToken, fetchLMSRole, logoutGuruToken } from './auth'
import { TCommonError } from './interfaces/common'
import { SESSION } from './constant'

const logoutNotification = (isNotAuthorized: boolean = false) => {
  if (isNotAuthorized) {
    notification.open({
      message: 'Anda tidak dapat mengakses halaman ini!',
      description:
        'Silakan login kembali menggunakan akun yang memiliki akses.',
      type: 'error',
      duration: 8,
    })
    return
  }

  notification.open({
    message: 'Anda berhasil log out!',
    type: 'success',
  })
}

export const authProvider: AuthProvider = {
  login: async ({ credential }: CredentialResponse) => {
    const tokenId = credential
    if (tokenId) {
      try {
        const guruSessionData = await fetchGuruToken({ tokenId })
        if (!guruSessionData.user) return Promise.reject()

        let { user } = guruSessionData

        const { LMSRole, lptkId } = await fetchLMSRole({
          guruToken: user.guruToken,
        })
        user.user = {
          ...user.user,
          LMSRole,
          lptkId,
        }

        Cookies.set(SESSION.USER_SESSION, JSON.stringify(user), {
          expires: new Date(user.expiredAt),
          path: '/',
        })

        return Promise.resolve()
      } catch {
        return Promise.reject()
      }
    }

    return Promise.reject()
  },
  logout: async (param?: { redirectPath: { cause: string } }) => {
    try {
      const user = Cookies.get(SESSION.USER_SESSION)
      if (user) {
        const parsedUser = JSON.parse(user)
        const guruToken = parsedUser.guruToken
        logoutGuruToken(guruToken)
      }
      sessionStorage.clear()
      googleLogout()
      Cookies.remove(SESSION.USER_SESSION)

      const isNotAuthorized =
        param?.redirectPath.cause === 'notAuthorized' || false

      logoutNotification(isNotAuthorized)
      return Promise.resolve()
    } catch {
      return Promise.reject()
    }
  },
  checkError: (error: TCommonError) => {
    if (error && error.statusCode === 401) {
      return Promise.reject({ cause: 'notAuthorized' })
    }

    return Promise.resolve()
  },
  checkAuth: async (ctx) => {
    let userSession: string | undefined
    if (ctx?.req) {
      const cookieStr: string = ctx.req.headers.cookie || ''
      const parsed = Object.fromEntries(
        cookieStr.split(';').map((c: string) => {
          const [key, ...val] = c.trim().split('=')
          return [key, decodeURIComponent(val.join('='))]
        }),
      )
      userSession = parsed[SESSION.USER_SESSION]
    } else {
      userSession = Cookies.get(SESSION.USER_SESSION)
    }
    return userSession ? Promise.resolve() : Promise.reject()
  },

  getPermissions: () => Promise.resolve(),
  getUserIdentity: async () => {
    const user = Cookies.get(SESSION.USER_SESSION)
    if (user) {
      const parsedUser = JSON.parse(user)
      return Promise.resolve(parsedUser)
    }
    return Promise.reject()
  },
}
